<template>
  <div class="profile">
      <div class="inner">
        <div class="pub-title title1" id="q0">
          <span>{{ $t('introduce') }}</span>
        </div>
        <img class="right-img wap" v-if="prod.kvUrl" :src="prod.kvUrl" alt="">
        <div class="introduce">
          <ul>
            <li v-if="prod['conferenceName' + En]">
              <i18n path="conferenceName" tag="span">
              </i18n>
              <span class="cont">{{ prod['conferenceName' + En] }}</span>
            </li>
            <li v-if="prod['conferenceTime' + En]">
              <i18n path="conferenceTime" tag="span">
              </i18n>
              <span class="cont">{{ prod['conferenceTime' + En] }}</span>
            </li>
            <li v-if="prod['conferenceAddress' + En]">
              <i18n path="venue" tag="span">
              </i18n>
              <span class="cont">{{ prod['conferenceAddress' + En] }}</span>
            </li>
            <li v-if="prod['conferenceTheme' + En]">
              <i18n path="conferenceTheme" tag="span">
              </i18n>
              <span class="cont">{{ prod['conferenceTheme' + En] }}</span>
            </li>
            <li v-if="prod['conferenceForm' + En]">
              <i18n path="conferenceFormat" tag="span">
              </i18n>
              <span class="cont">{{ prod['conferenceForm' + En] }}</span>
            </li>
          </ul>
          <p v-if="prod['content' + En]">
            <span v-for="(item, index) in prod['content' + En].split('<br/>')" :key="index" v-html="item"></span>
          </p>
          <img class="right-img pc" v-if="prod.kvUrl" :src="prod.kvUrl" alt="">
        </div>
      </div>
      <div class="wangjie zindex11" id="q1">
        <div class="pub-title">
          <span>{{ $t('pastReview') }}</span>
        </div>
        <div class="content" v-if="list && list.length">
          <swiper ref="mySwiper" :options="isPc ? swiperOptions : swiperOptionsWap" class="my-swiper" id="swiper">
            <swiper-slide v-for="(item, index) in list" :key="index">
                <div class="item" @click="toWangjie(index, item['fileTitle' + En])">
                  <img :src="item.fileUrl" alt="">
                  <div class="text">
                    <div class="title"><span class="ellipsis2">{{ item['fileTitle' + En] }}</span></div>
                  </div>
                </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-btns">
            <img src="https://static.worldaic.com.cn/2024/web/static/images/prev.png" alt="" @click="prevTo('prev')" class="prev btn-img">
            <img src="https://static.worldaic.com.cn/2024/web/static/images/next.png" alt="" @click="prevTo('next')" class="next btn-img">
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import protal from "@/api/protal"

export default {
  name: 'profile',
  data() {
    return {
      prod: {},
      swiperOptions: {
        slidesPerView: 3,
      },
      swiperOptionsWap: {
        autoplay: 3000,
        autoplayDisableOnInteraction : false,
        slidesPerView: 3,
        loop: true,
      },
      list: [],
      dates: []
    }
  },
  created() {
    this.pageView('gw_profilePage');
    this.getProd();
    protal.getZdType('previous_year').then(res => {
      const arr = res.data || []
      this.dates = arr.filter(x => x.lableValue !== 'hide').map(x => x.lableDesc)
      arr.filter(x => x.lableValue !== 'hide').forEach((x, i) => {
        this.getData(x.uuid)
      })
      this.list = arr.filter(x => x.lableValue !== 'hide').map(x => ({ yearUuid: x.uuid }))
    })
  },
  methods: {
    toWangjie(index, label) {
      this.$jsAPI('track','pastReview',
          {
            'position_var': index + 1 + '',
            'contentName_var': label 
          }
      );
      gio('track','pastReview',
          {
            'position_var': index + 1 + '',
            'contentName_var': label 
          }
      );
      console.log('pastReview', {
            'position_var': index + 1 + '',
            'contentName_var': label 
          })
      this.$router.push('/wangjie?year=' + this.dates[index])
    },
    getData(yearUuid) {
      protal.queryPreviousReviewsList({ pageNum: 1, pageSize: 1, yearUuid }).then(res => {
        const obj = res.data && res.data[0] || {}
        this.list = this.list.map(x => {
          if (x.yearUuid === obj.yearUuid) {
            x = obj
          }
          return x
        })
      })
    },
    getProd() {
      protal.getConfigByCode('official_introduction').then(res => {
        this.prod = res.data.data
      })
      // protal.getJson('waic__Introduction', data => {
      //   this.prod = data || {}
      //   console.log(JSON.stringify(data), 1111)
      // })
    },
    prevTo(str) {
      if (str === 'prev') {
        this.$refs.mySwiper.swiper.slidePrev()
      } else {
        this.$refs.mySwiper.swiper.slideNext()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .profile {
    padding: 1.65rem 0 1.5rem;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/dahui-bg.jpg);
    background-size: 100% auto;

    .inner {
      width: 15rem;
      margin: 0 auto;

      p {
        font-size: .2rem;
        color: #595959;
        line-height: .32rem;
        margin-top: .36rem;
        background: url(https://static.worldaic.com.cn/2024/web/static/images/profile-bg.png) no-repeat;
        background-size: 100% auto;

        span {
          display: block;
          margin-bottom: .2rem;
        }
      }
    }

    .introduce {
      position: relative;

      .right-img {
        position: absolute;
        right: 0;
        top: -0.16rem;
        width: 7.2rem;
        // height: 2.8rem;
        height: auto;
        border-radius: .16rem;
      }

      p {
        span {
          font-size: .18rem;
          line-height: .28rem;
          color: #595959;
        }
      }
    }

    ul {
      margin-top: .7rem;
      padding-bottom: .14rem;
      width: 6.4rem;
      min-height: 2.54rem;
      border-bottom: 1px solid RGBA(190, 191, 192, 1);

      li {
        font-size: .22rem;
        font-weight: 500;
        color: #808080;
        line-height: .33rem;
        margin-bottom: .15rem;
        display: flex;
        
        span {
          display: inline-block;
          font-family: sybold;

          &:nth-child(1) {
            width: 1.08rem;
          }

          &:nth-child(2) {
            color: #595959;
            flex: 1;
            overflow: hidden;
          }
        }
      }
    }

    .wangjie {
      margin-top: .6rem;

      .content {
        position: relative;
        width: 15rem;
        margin: .56rem auto 0;

        .my-swiper {
          width: 100%;

          .item {
              display: inline-block;
              vertical-align: top;
              width: 4.86rem;
              border-radius: .16rem;
              background: #F6F7F7;
              overflow: hidden;
              white-space: normal;
              cursor: pointer;
            
              img {
                display: block;
                width: 100%;
                height: 3.24rem;
                border-radius: .16rem;
              }

              .text {
                padding: 0 .16rem;

                .title {
                  font-size: .22rem;
                  font-weight: 500;
                  color: #3E3A39;
                  display: flex;
                  align-items: center;
                  line-height: 1.5;
                  height: 1rem;
                  font-family: sybold;
                }

                p {
                  font-size: .14rem;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 400;
                  color: #727171;
                  line-height: .24rem;
                  height: .48rem;
                  margin-top: .05rem;
                }

                .btn {
                  text-align: right;
                  padding-top: .1rem;
                  height: .2rem;

                  span {
                    font-size: .14rem;
                    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                    font-weight: 400;
                    color: #595757;
                    line-height: 1;
                    cursor: pointer;
                  }
                }

                .box {
                  height: 1rem;
                  transition: .5s;
                  overflow: hidden;
                }
              }

              &:hover .text {
                .box {
                  height: 1rem;
                }
              }
            }
        }

        .btn-img {
          position: absolute;
          top: 1.52rem;
          cursor: pointer;
          width: .5rem;
          height: auto;

          &.prev {
            left: -0.86rem;
          }

          &.next {
            right: -0.86rem;
          }
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .profile {
    padding: 1.57rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/wap-bg.jpg);
    background-size: 100% auto;

    .inner {
      width: 6.86rem;
      margin: 0 auto;

      p {
        font-size: .26rem;
        color: #595959;
        line-height: .38rem;
        margin-bottom: .2rem;
        background: url(https://static.worldaic.com.cn/2024/web/static/images/profile-bg.png) no-repeat;
        background-size: 100% auto;

        span {
          display: block;
          margin-bottom: .2rem;
        }
      }
    }

    .right-img {
      width: 100%;
      height: auto;
      border-radius: .16rem;
      margin-top: .59rem;
      display: block;
    }

    .introduce {
      position: relative;

      .right-img {
        position: absolute;
        right: 0;
        top: -0.22rem;
        width: 7.2rem;
        height: 2.8rem;
        border-radius: .16rem;
      }
    }

    ul {
      padding-bottom: .28rem;
      margin-bottom: .38rem;
      border-bottom: 1px solid RGBA(190, 191, 192, 1);

      li {
        font-size: .26rem;
        font-weight: 500;
        color: #808080;
        line-height: 1;
        margin-top: .25rem;
        
        span {
          display: inline-block;
          font-family: sybold;

          &:nth-child(1) {
            width: 1.29rem;
          }

          &:nth-child(2) {
            color: #595959;
          }
        }
      }
    }

    .wangjie {
      margin-top: 1.25rem;
      width: 100%;
      overflow: hidden;

      .content {
        position: relative;
        width: 15.36rem;
        margin: .67rem auto 0;
        overflow: hidden;
        left: -3.83rem;

        .my-swiper {
          width: 100%;

          .item {
              display: inline-block;
              vertical-align: top;
              width: 4.86rem;
              border-radius: .16rem;
              background: #F6F7F7;
              overflow: hidden;
              white-space: normal;
            
              img {
                display: block;
                width: 100%;
                height: 3.24rem;
                border-radius: .16rem;
              }

              .text {
                padding: 0 .16rem;

                .title {
                  font-size: .28rem;
                  font-weight: 500;
                  color: #3E3A39;
                  display: flex;
                  align-items: center;
                  line-height: 1.5;
                  height: 1.2rem;
                  font-family: sybold;

                  span {
                    line-height: .42rem;
                    height: .82rem;
                  }
                }

                p {
                  font-size: .14rem;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 400;
                  color: #727171;
                  line-height: .24rem;
                  height: .48rem;
                  margin-top: .05rem;
                }

                .btn {
                  text-align: right;
                  padding-top: .1rem;
                  height: .2rem;

                  span {
                    font-size: .14rem;
                    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                    font-weight: 400;
                    color: #595757;
                    line-height: 1;
                    cursor: pointer;
                  }
                }

                .box {
                  height: 1.28rem;
                  transition: .5s;
                  overflow: hidden;
                }
              }

              &:hover .text {
                .box {
                  height: .88rem;
                }
              }
            }
        }

        .btn-img {
          position: absolute;
          top: 1.52rem;
          cursor: pointer;
          width: .5rem;
          height: auto;

          &.prev {
            left: -0.86rem;
          }

          &.next {
            right: -0.86rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/profile/index.vue